'use client';

import React, { memo, useMemo } from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/nasca-logo-white-transparent-1777884010573.png',
  iconName = 'SparklesIcon',
  size = 130,
  width,
  height,
  className = '',
  onClick,
}: AppLogoProps) {
  const resolvedWidth = width ?? size;
  const resolvedHeight = height ?? (width ? undefined : 46);

  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  return (
    <div className={containerClassName} onClick={onClick}>
      {src ? (
        <AppImage
          src={src}
          alt="NASCA Capital Logo"
          width={resolvedWidth}
          height={resolvedHeight ?? resolvedWidth}
          className="flex-shrink-0"
          style={{ width: resolvedWidth, height: resolvedHeight ?? 'auto' }}
          priority={true}
          unoptimized={src.endsWith('.svg')}
        />
      ) : (
        <AppIcon name={iconName} size={size} className="flex-shrink-0" />
      )}
    </div>
  );
});

export default AppLogo;
